<aside class="main-sidebar sidebar-light sidebar-light-blue elevation-4">
    <!-- Brand Logo -->
    <a href="https://firmenstammdaten.persona-service.de/" class="brand-link navbar-success">
        <img src="/assets/images/ps_logo.png" alt="" class="brand-image img-circle elevation-3" style="opacity: .8">
        <span class="brand-text">Firmenverwaltung</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
        <!-- Sidebar user panel (optional) -->
        <div class="user-panel mt-3 pb-3 mb-3 d-flex">
            <div class="image">

            </div>
            <div class="info">
                {{ userService.UserName }}
            </div>
        </div>

        <!-- Sidebar Menu -->
        <nav class="mt-2">
            <ul class="nav nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-item" *ngFor="let item of menuItems">
                    <a [routerLink]="item.path" class="nav-link" routerLinkActive="router-link-active"
                       [class.current-page]="router.url === item.path || router.url.includes(item.path) && item.path !== '/'">
                        <i class="nav-icon {{ item.iconClass }}"></i>
                        <p>
                            {{item.title}}
                        </p>
                    </a>
                </li>
            </ul>
        </nav>
        <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
</aside>
